export default __webpack_public_path__ + "static/media/pudding.6f80a1d5.jpg";